module.exports = __webpack_public_path__ + "static/media/gameover.1c5e191f.wav";